import { MenuItem } from "@mui/material";
import Select from "../../select/select";
import Typography from "../../typography/typography";

const CombinatorSelect = (props: any) => {
  const { handleOnChange, value, options, ...rest } = props;

  const showDropdown = props.path?.[0] === 1 || props.path?.[1] === 1;

  return (
    <>
      {!showDropdown ? (
        <Typography
          type="s4"
          color="theme.secondary.1000"
          className="combinator-value"
        >
          {value}
        </Typography>
      ) : (
        <Select
          value={value}
          onChange={(e: any) => handleOnChange(e.target.value)}
          {...rest}
          className="combinator-list"
        >
          {options?.map(({ name, label }: { name: string; label: string }) => (
            <MenuItem key={name} value={name}>
              <Typography type="s4" color="theme.secondary.1000">
                {label}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      )}
    </>
  );
};

export { CombinatorSelect };
export default CombinatorSelect;
